<template>
    <div>
        <v-row class="pa-10">
            <v-text-field v-model="search" outlined dense label="Search"></v-text-field>
        </v-row>
        <v-data-table :search="search" :items="callLogs" :headers="headers" :loading="loading"> </v-data-table>
    </div>
</template>

<script>
import { fetchCallLogs } from '@/api'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `CdfwCallLogs`,
    data() {
        return {
            search: ``,
            loading: true,
            callLogs: [],
            headers: [
                {
                    text: 'Date/Time',
                    align: 'start',
                    sortable: true,
                    value: 'originatingdatetime'
                },
                {
                    text: 'Calling Party #',
                    align: 'start',
                    sortable: true,
                    value: 'callingpartynumber'
                },
                {
                    text: 'Destination',
                    align: 'start',
                    sortable: true,
                    value: 'destination'
                },
                {
                    text: 'Final Called Party #',
                    align: 'start',
                    sortable: true,
                    value: 'finalcalledpartynumber'
                },
                {
                    text: 'Terminating Device Name',
                    align: 'start',
                    sortable: true,
                    value: 'terminatingdevicename'
                },
                {
                    text: 'Terminating Device Description',
                    align: 'start',
                    sortable: true,
                    value: 'terminatingdevicedescription'
                },
                {
                    text: 'Ring Time',
                    align: 'start',
                    sortable: true,
                    value: 'ringtime'
                },
                {
                    text: 'Call Duration',
                    align: 'start',
                    sortable: true,
                    value: 'callduration'
                },
                {
                    text: 'Originating Cause Code',
                    align: 'start',
                    sortable: true,
                    value: 'originatingcausecode'
                },
                {
                    text: 'Terminating Cause Code',
                    align: 'start',
                    sortable: true,
                    value: 'terminatingcausecode'
                }
            ]
        }
    },
    computed: {},
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            const results = (await fetchCallLogs({})).data
            this.callLogs = results
            this.loading = false
        }
    }
}
</script>
